/* Fire a GA4 event when the tag is present (production); no-op everywhere
   else, so components can call this unconditionally. */
export function trackEvent(name, params = {}) {
  if (typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}
